<a mat-list-item *ngIf="item.visible" [ngStyle]="{'padding-left': (depth * 12) + 'px'}"
  (click)="onItemSelected(item)"
  [ngClass]="{'active': isRouteActive(item), 'expanded': expanded}">
  
  <mat-icon class="routeIcon" [ngStyle]="{'color': item.iconColor}">{{ item.iconName }}</mat-icon>
  {{ item.displayName }}

  <span fxFlex *ngIf="item.children && item.children.length" style="padding-top: 7px; padding-left: 20px;">
    <span fxFlex></span>
    <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
      expand_more
    </mat-icon>
  </span>
</a>

<!-- Child menus -->
<div *ngIf="expanded">
  <app-menu-list *ngFor="let child of item.children" [item]="child" [depth]="depth + 1">
  </app-menu-list>
</div>
